import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30b9db4d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Please Choose the Room", -1))
const _hoisted_2 = { class: "footer-buttons" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Back to menu ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Enter Room ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_room_card = _resolveComponent("room-card")!
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rooms, (room) => {
        return (_openBlock(), _createBlock(_component_room_card, {
          key: room.roomId,
          roomId: room.roomId,
          roomName: room.roomName,
          roomPlayersCount: room.players
        }, null, 8, ["roomId", "roomName", "roomPlayersCount"]))
      }), 128))
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
          class: "left-btn"
        }, [
          _createVNode(_component_fa_icon, {
            icon: "arrow-left",
            size: "lg"
          }),
          _hoisted_3
        ]),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.joinRoom())),
          class: "right-btn"
        }, [
          _hoisted_4,
          _createVNode(_component_fa_icon, {
            icon: "arrow-right",
            size: "lg"
          })
        ])
      ])
    ]),
    _: 1
  }))
}